import { calculateDiscountedAmount } from "..";
export const URL_PARAMS = {
    SUCCESS: {
        success: "true",
        loading: "true"
    },
    FAIL: {
        fail: "true",
        loading: "false"
    }
};
// 유틸리티 함수 외부로 분리
export const createUrlWithParams = (params)=>{
    const url = new URL(window.location.href);
    Object.entries(params).forEach((param)=>{
        let [key, value] = param;
        url.searchParams.set(key, value);
    });
    return url.toString();
};
// 결제 검증 로직 분리
export const validatePaymentConditions = (param)=>{
    let { info , total  } = param;
    if (!info) {
        ;
        return false;
    }
    if (total <= 0) {
        ;
        return false;
    }
    return true;
};
export const findOrderItemPrice = (item)=>{
    return item.productSourceType === "pod" ? item.pod.options.price : item.price;
};
// 상품 쿠폰 할인 금액 계산
export const calculateProductDiscount = (orderItems)=>{
    return orderItems.reduce((total, item)=>{
        if (item.isCouponApplied && typeof item.discountedPrice === "number") {
            const originalPrice = findOrderItemPrice(item);
            const discount = parseInt(calculateDiscountedAmount({
                price: originalPrice,
                discount: item.discountedPrice
            }));
            return total + discount;
        }
        return total;
    }, 0);
};
// 최종 결제 금액 계산
export const calculateFinalPrice = (params)=>{
    const { originalPrice , productDiscount , deliveryFee , remoteAreaFee , deliveryDiscount , usedCash , usedPoint  } = params;
    // 총 상품 가격 (할인 적용)
    const productPrice = originalPrice - productDiscount;
    // 총 배송비 (할인 적용)
    const totalDeliveryFee = Math.max(0, deliveryFee + remoteAreaFee - deliveryDiscount);
    // 최종 가격 (캐시/포인트 적용)
    const finalPrice = Math.max(0, productPrice + totalDeliveryFee - usedCash - usedPoint);
    return finalPrice;
};
// 캐시 상품 적립 포인트 계산
export const calculateSavedPoint = (param)=>{
    let { bonusPointType , bonusPointValue , price  } = param;
    if (!bonusPointValue || !price) return 0;
    if (bonusPointType === "PERCENT") {
        return Math.floor(bonusPointValue * price / 100);
    }
    return bonusPointValue;
};
